import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type.ts';

export const getNextPage = (data: PaginationResponseType<any>) => {
  if (data.current < data.page_count) {
    return data.current + 1;
  }
  return undefined;
};
